import React from "react";
import Product from "../components/Product";
import { useState, useEffect } from "react";
import axios from "axios";
import "./CategoryPage.css";
import { useParams } from "react-router-dom";
import category1 from "../assets/img/categories/1.png";
import category2 from "../assets/img/categories/2.png";
import category3 from "../assets/img/categories/4.png";

function CategoryPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);

  const params = useParams();
  const getProducts = async () => {
    try {
      const response = await axios({
        method: "GET",

        url:
          process.env.REACT_APP_API_URL +
          `/api/categories/${params.categorySlug}`,
      });
      setProducts(response.data.products);
      setCategory(response.data);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <>
      <header className="position-relative w-100 pages-header">
        <h1 className="animate__animated animate__fadeInUp position-absolute text-white text-shadow categories-title w-100">
          {category.name}
        </h1>
        {params.categorySlug === "blacktea" && (
          <img
            className="img-fluid header-img"
            src={category2}
            alt="imgCategory"
          />
        )}
        {params.categorySlug === "greentea" && (
          <img
            className="img-fluid header-img"
            src={category1}
            alt="imgCategory"
          />
        )}
        {params.categorySlug === "herbaltea" && (
          <img
            className="img-fluid header-img"
            src={category3}
            alt="imgCategory"
          />
        )}
      </header>

      <div className="container animate__animated animate__fadeIn mt-5 mb-5 pb-5">
        <div className="row justify-content-center gy-5">
          {products.length > 0 &&
            products.map((product) => (
              <div
                className="col-lg-3 col-md-4 col-6 product-container d-flex justify-content-center"
                key={product.id}
              >
                <Product product={product} />
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default CategoryPage;
